module.exports = __webpack_public_path__ + "static/media/2DGACM14.89a01fa5.jpg";